import { RiskIncidentSidePanelWebComponent } from './component/RiskIncidentSidePanelWebComponent';
import { WEB_COMPONENT_RISK_INCIDENT_SIDE_PANEL } from '../../webcomponents.constants';

export { RiskIncidentSidePanelWebComponent };

window.customElements.define(WEB_COMPONENT_RISK_INCIDENT_SIDE_PANEL, RiskIncidentSidePanelWebComponent);
